export const MODE_NON_CONNECTE = "NON_CONNECTE";
export const MODE_MESSAGING_NON_CONNECTE = "MESSAGING_NON_CONNECTE";
export const MODE_MESSAGING_CONNECTE = "MESSAGING_CONNECTE";
export const MODE_CONNECTE = "CONNECTE";